import React, { useEffect, useState } from "react"
import { MdPhone, MdAddIcCall, MdCallEnd } from "react-icons/md"
// import { ReactSipPhone, phoneStore } from "react-sip-phone-web"
import { Button } from "../../components/Button"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import { initFirebaseAnalytics } from "../../core/firebase"
// import "react-sip-phone-web/dist/index.css"
import { customToast } from "../../components/Toast"
import { RiWhatsappFill } from "react-icons/ri"
import { UserAvatarInfo } from "../../components/UserList"

const formatPhoneNumber = (phone) => {
  const dddAndNumber = phone.slice(3)
  const ddd = dddAndNumber.slice(0, 2)

  let number = dddAndNumber.slice(2)
  if (number.length !== 9) {
    number = "9" + number
  }

  return `${ddd}${number}`
}

const PhoneContainer = ({ value, name, scope, currentUser, row, isCard = false, ...props }) => {
  const [inCall, setInCall] = useState()
  const [open, setOpen] = useState()

  const makeCall = async () => {
    setInCall(true)
    const userToInitCall = row?.original || props?.props

    const res = await saveAnalyticsCall(userToInitCall)

    if (res.status === "success") {
      // const number = formatPhoneNumber(value)
      // const sipAccount = phoneStore.getState().sipAccounts.sipAccount
      // if (sipAccount && number) {
      //   sipAccount.makeCall(number)
      // }
    } else {
      customToast(res?.message || "erro ao completar ligação")
    }
  }

  const saveAnalyticsCall = async (producer) => {
    try {
      if (!producer || !producer?.id) {
        throw new Error("Usuário não econtrado")
      }

      if (!scope || !scope?.id) {
        throw new Error("Projeto não econtrado")
      }

      if (!currentUser || !currentUser?.id) {
        throw new Error("Técnico não econtrado")
      }

      const responseCall = await initFirebaseAnalytics("call_made", {
        userId: currentUser.id, // técnico
        producer: producer.id, // produtor
        producerPhone: producer.phone, // número do produtor
        project: scope?.id, // projeto
        from: "web", // De onde foi feita? (web/mobile)
      })

      return { status: "success", message: responseCall }
    } catch (err) {
      return { status: "error", message: err?.message }
    }
  }

  const endCall = () => {
    setOpen(false)
    const userAgent = phoneStore.getState().sipAccounts.userAgent

    userAgent.stop()
    setInCall(false)
  }

  useEffect(() => {
    if (!open) {
      setInCall(false)
    }

    return () => {
      try {
        const userAgent = phoneStore.getState().sipAccounts.userAgent
        userAgent.stop()
      } catch (e) {
        // console.log({ e })
      }
    }
  }, [open])

  const WhatsAppComponent = () => {
    return (
      <div
        onClick={() =>
          window.open(
            `https://wa.me/${row?.original?.whatsapp?.split("+")[1]}`,
            "_blank",
            "noopener,noreferrer",
          )
        }
        title="Abrir WhatsApp"
        style={{ marginLeft: 5 }}>
        {row?.original?.whatsapp}
      </div>
    )
  }

  return value !== "" ? (
    <div className="phone-cell">
      {/* <MdPhone
        title={`Ligar para ${row?.original?.name || name}`}
        className="phone-icon-list"
        onClick={() => setOpen(true)}
      /> */}
      {row?.original?.whatsapp && <WhatsAppComponent />}
      {open && (
        <ModalPanel modalIsOpen={open}>
          <ModalHeader
            closeModal={() => setOpen(false)}
            title={inCall ? "Em Chamada..." : "Realizar Chamada"}
          />
          <ModalBody>
            <UserAvatarInfo
              {...{ row: row || props?.props || { phone: value, name }, phone: true }}
            />
          </ModalBody>
          <ModalFooter>
            <div className="buttons-phone">
              {!inCall ? (
                <>
                  <Button
                    hasIcon={<MdAddIcCall size={16} />}
                    label="Ligar"
                    handleClick={() => makeCall()}
                    color="orange"
                  />
                </>
              ) : (
                <Button
                  hasIcon={<MdCallEnd size={16} />}
                  label="Encerrar"
                  handleClick={() => endCall()}
                  color="danger"
                />
              )}
            </div>
          </ModalFooter>
        </ModalPanel>
      )}
      {/* {open && (
        <ReactSipPhone
          name={"ManejeBem"}
          sipCredentials={{
            sipuri: "70806001@54.233.253.44",
            password: "7494108a",
          }}
          sipConfig={{
            websocket: "wss://app.nvoip.com.br:7443",
            defaultCountryCode: "",
          }}
          phoneConfig={{
            // displayIncoming: true,
            disabledFeatures: [],
            disabledButtons: [],
            //sessionsLimit: 2,
            handleOutgoingCall: () => {
              console.log("onEnd")
            },
          }}
          appConfig={{
            mode: "strict",
          }}
        />
      )} */}
    </div>
  ) : (
    <div className="phone-cell--empty">{row?.original?.whatsapp && <WhatsAppComponent />}</div>
  )
}

export default PhoneContainer
